import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export const ChatbotEmptyState = () => {
	const { t } = useTranslation();

	return (
		<div className="chatbot-empty-state">
			<div className="chatbot-header-icon chatbot-empty-state-icon">
				<Sparkles className="icon-big" />
			</div>
			<p className="size-18 text-center m-0">
				{t(
					"globalChatbot.emptyState",
					"Rozpocznij konwersację wpisując pytanie w pole poniżej",
				)}
			</p>
		</div>
	);
};
